const ErrorMsg = () => {
  return <h1 className="error-msg">Error : Something went wrong try again</h1>;
};

export default ErrorMsg;
